import {ChangeEvent, useState} from 'react'
import {KTIcon} from '../../../../_metronic/helpers'
import {useSenderIdProvider} from '../context/SenderIdProvider'
import {Route} from '../core/_model'
import useSenderIdsOptions from '../../../hooks/useSenderIdsOptions'
import SecondarySelectBox from '../../../utils/components/SecondarySelectBox'
import {ISelectOption} from '../../../utils/core/_model'
import {useUserStateProvider} from '../../../utils/contextProvider/UserStateProvider'
import {useAuth} from '../../auth'

const SenderIdFilter = () => {
  const {currentUser} = useAuth()
  const {isGlobalP2p} = useUserStateProvider()
  const {
    isLoading,
    options: routes,
    handleItemsPerPage,
    parameters,
    handleFilterValue,
    onResetFilter,
    handleSenderFilter,
  } = useSenderIdProvider()
  const {senderIdsOptions} = useSenderIdsOptions()

  const [filterData, setFilterData] = useState({
    status: '',
    route: '',
    branded: '',
    sender: '',
  })

  const isAdmin = currentUser?.author_id === 0

  const onHandleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const {value, name} = e.target

    setFilterData((prevState) => ({
      ...prevState,
      [name]: value,
    }))

    if (name === 'sender') {
      handleSenderFilter(value)
    } else {
      handleFilterValue(name, parseInt(value))
    }
  }

  const onChangeSender = (
    selectedId: number | string | null,
    option: ISelectOption | null | undefined
  ) => {
    console.log(selectedId, option)
    if (selectedId && option) {
      handleSenderFilter(option.value)
    } else {
      handleSenderFilter('')
    }
  }

  const handleResetFilter = () => {
    setFilterData({
      status: '',
      route: '',
      branded: '',
      sender: '',
    })

    onResetFilter()
  }

  return (
    <>
      {/* begin::Filter Button */}
      <button
        disabled={isLoading}
        type='button'
        className='btn btn-light-primary border border-1 border-gray-500'
        id='dropdownMenuButton'
        data-bs-toggle='dropdown'
        // aria-haspopup='true'
        aria-expanded='false'
        data-bs-auto-close='outside'
      >
        <KTIcon iconName='filter' className='fs-2' />
        Filter
      </button>
      {/* end::Filter Button */}
      {/* begin::SubMenu */}
      <div
        className='dropdown-menu menu menu-sub menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-300px w-md-325px py-4'
        aria-labelledby='dropdownMenuButton'
      >
        {/* begin::Header */}
        <div className='px-7 py-5'>
          <div className='fs-5 text-gray-900 fw-bolder'>Filter Options</div>
        </div>
        {/* end::Header */}

        {/* begin::Separator */}
        <div className='separator border-gray-200'></div>
        {/* end::Separator */}

        {/* begin::Content */}
        <div className='px-7 py-5' data-kt-user-table-filter='form'>
          {/* begin::Input group */}
          <div className=''>
            <label className='form-label fs-6 fw-bold'>Show Entries:</label>
            <select
              className='form-select fw-bolder custom-input'
              data-kt-select2='true'
              data-placeholder='Select entries'
              data-hide-search='true'
              name='entries'
              id='entries'
              value={parameters.pageSize}
              onChange={(e) => {
                // setCurrentPage(1)
                // setItemsPerPage(parseInt(e.target.value))
                handleItemsPerPage(parseInt(e.target.value))
              }}
            >
              <option value='10'>10</option>
              <option value='50'>50</option>
              <option value='100'>100</option>
              <option value='250'>250</option>
            </select>
          </div>
          {/* end::Input group */}
        </div>

        <div className='px-7 pb-6' data-kt-user-table-filter='form'>
          {/* begin::Input group */}
          <div className='mb-2'>
            <label className='form-label fs-6 fw-bold'>Status</label>
            <select
              className='form-select fw-bolder custom-input'
              data-kt-select2='true'
              data-placeholder='Select status'
              data-hide-search='true'
              name='status'
              id='status'
              value={filterData.status}
              onChange={onHandleChange}
            >
              <option value=''>Select status</option>
              <option value='1'>Active</option>
              <option value='0'>Inactive</option>
            </select>
          </div>
          {/* end::Input group */}

          {/* begin::Input group */}
          {isGlobalP2p && isAdmin && (
            <div className='mb-2'>
              <label className='form-label fs-6 fw-bold'>Type</label>
              <select
                className='form-select fw-bolder custom-input'
                data-kt-select2='true'
                data-placeholder='Select type'
                data-hide-search='true'
                name='branded'
                id='branded'
                value={filterData.branded}
                onChange={onHandleChange}
              >
                <option value=''>Select branded</option>
                <option value='2'>P2P</option>
                <option value='0'>A2P</option>
              </select>
            </div>
          )}
          {/* end::Input group */}

          {/* begin::Input group */}
          <div className='mb-2'>
            <label className='form-label fs-6 fw-bold'>Route Name</label>
            <select
              className='form-select fw-bolder custom-input'
              data-kt-select2='true'
              data-placeholder='Select route'
              data-hide-search='true'
              name='route'
              id='route'
              value={filterData.route}
              onChange={onHandleChange}
            >
              <option value=''>Select status</option>
              {routes.map((route: Route) => (
                <option key={route.id} value={route.id}>
                  {route.name}
                </option>
              ))}
            </select>
          </div>
          {/* end::Input group */}

          {/* begin::Input group */}
          <div className='mb-2'>
            <label className='form-label fs-6 fw-bold'>Sender</label>
            <SecondarySelectBox
              options={senderIdsOptions}
              placeholder='Select sender'
              onChange={onChangeSender}
              isClearable
            />
          </div>
          {/* end::Input group */}

          <div className='text-end mt-4'>
            <button className='btn btn-danger fw-bold' onClick={handleResetFilter}>
              Reset
            </button>

            {/* <button className='ms-2 btn btn-primary fw-bold' onClick={onApplyFilter}>
              Apply
            </button> */}
          </div>
        </div>

        {/* end::Content */}
      </div>
      {/* end::SubMenu */}
    </>
  )
}

export default SenderIdFilter
